module.exports = __webpack_public_path__ + "media/images/icons/close-6c8c7f6962bb9e895a98f995e9add667.svg";